import { useMutation } from "@tanstack/react-query";
import {
  getFactories,
  getMovieSubtitle,
  ignoreMovie,
  setMovieToFactory,
} from "../requests/factory";

export const useGetFactories = () => useMutation(getFactories);

export const useSetMovieToFactory = () => useMutation(setMovieToFactory);

export const useGetMovieSubtitle = () => useMutation(getMovieSubtitle);

export const useIgnoreMovie = () => useMutation(ignoreMovie);
